import { lines } from '../data/lines'
import Moment from 'moment'
import { url } from './url'

const zeroTimeout = (func: any) => setTimeout(func, 0)

const allStations = Object.entries(lines["mmrcl"]).flatMap(([line_name, line]: any) =>
	line.stations.map((s: any) => ({ line_name, ...s }))
)

const getStationNameForCode = (code: any, lang: any) => {
	const res = allStations.filter((s) => s.code === code)
	if (res?.length) {
		return res[0][lang === 'hi' ? 'name_hi' : lang === 'mr' ? 'name_mr' : 'name']
	}
}
function highlightFlag(kind: any, code: any) {
	document
		.querySelectorAll(`.${kind}Flags div`)
		.forEach((el: any) => (el.style.visibility = 'hidden'))
	document.querySelector(`#${code}${kind}Flag` as any).style.visibility = 'visible'
}

async function getMapData(journeyPlan: any, lang: any) {
	const date: any = new Date(journeyPlan?.date)?.toString()
	const correctDate =
		typeof date === 'string'
			? date.replace('Z', '')
			: date.toISOString().replace('Z', '')
	const headers = new window.Headers()
	headers.set('Content-Type', 'application/json')
	if (journeyPlan.from && journeyPlan.to) {
		try {
			const res = await window.fetch(
				`${url?.baseUrl}/${lang}${url?.station_route}${journeyPlan?.from}/${journeyPlan?.to}/${journeyPlan.fromType}/${journeyPlan.toType}/${journeyPlan.advanced}/${Moment(correctDate, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ').format('YYYY-MM-DD')}/${journeyPlan?.journey}/`,
				{
					headers,
				}
			)
			const data = await res.json()
			if (data?.route && data?.route?.length) {
				const lines = data.route.flatMap((r: any) => r['map-path'])
				if (lines?.length) {
					return data
				}
			} else if(data?.return_journey === true) {
				return data
			}
		} catch (error) {
			return false
		}
		return false
	}
}

export {
	allStations,
	zeroTimeout,
	getStationNameForCode,
	highlightFlag,
	getMapData,
}
